"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentName = void 0;
const getComponentName = (Component) => Component.displayName || Component.name || 'Component';
exports.getComponentName = getComponentName;
//# sourceMappingURL=utils.js.map